import PropTypes from 'prop-types'
import {
  setDisconnectMessage as setDisconnectMessageAction,
  gracefulExit as gracefulExitAction,
  confirmCloseMessage as confirmCloseMessageAction,
} from '../../actions/disconnect'

const stateProps = {
  'disconnect.confirmCloseMessage': PropTypes.bool.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  disconnect: { confirmCloseMessage },
}) => {
  return (Boolean(confirmCloseMessage))
}

let dispatch = null

const onClose = () => {
  dispatch(confirmCloseMessageAction(false))
  dispatch(gracefulExitAction())
  dispatch(setDisconnectMessageAction('disconnect-by-you'))
}

const onCancel = () => {
  dispatch(confirmCloseMessageAction(false))
}

const buttons = [
  {
    text: 'btn-close',
    onClick: onClose,
  },
  {
    text: 'btn-cancel',
    onClick: onCancel,
  },
]

/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({
  state: { agent: { unattended } },
  dispatch: dispatchFunc,
}) => {
  dispatch = dispatchFunc

  // return modal data
  return {
    className: 'topmost',
    backdropClassName: 'topmost',
    iconClass: 'modal-icon-ondemand-disconnected',
    title: unattended ? 'close-session-title-unattended' : 'close-session-title',
    body: unattended ? 'close-session-text-unattended' : 'close-session-text',
    buttons,
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
